<template>
<v-container>
<v-window v-model="step" touchless>
  <v-window-item :value="1">
    <div class="purcharse-order mt-1">
      <v-toolbar>
        <v-spacer></v-spacer>
        <v-dialog v-model="newProductDialog">
          <v-icon slot="activator">add</v-icon>
          <products-product-form
            v-on:close-new-product="newProductDialog = false"
            v-on:error="onNewSampleError"
            v-on:success="onNewSampleSuccess"
           />
        </v-dialog>
      </v-toolbar>
      <v-card>
        <v-form @submit="searchProducts" v-model="valid" ref="searchStaticsForm" onSubmit="return false;">
          <v-card-text>
            <v-combobox v-model="select" :loading="loading" :items="items" :search-input.sync="search" item-text="serial_number" item-value="serial_number" class="mx-1" hide-no-data hide-details label="Numero de Serie" solo v-on:keyup.enter="searchProducts" ref="myAutocomplete2"></v-combobox>
            <v-slider v-model="price_ratio" min="0" max="100" label="Rel. Precio" thumb-label="always">

            </v-slider>
            <v-slider v-model="weigth_ratio" min="0" max="100" label="Rel. Peso" thumb-label="always">
            </v-slider>
            <v-slider v-model="samples" min="0" max="30" label="Min. muestras" thumb-label="always">

            </v-slider>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="submit" color="success">Buscar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
      <v-container v-if="updatedProducts.length > 0" mt-2>
        <v-card flat>
          <v-card-title primary-title>
            <span class="subheading">Catalizadores actualizados </span>
          </v-card-title>
          <v-card-text>
            <products-avg-product-list :products="updatedProducts" :pictures="updatedProductsPictures" v-on:select-product="selectProduct" />
          </v-card-text>
        </v-card>

      </v-container>

      <products-avg-product-list :products="products" :pictures="pictures" 
        v-on:select-product="selectProduct"
        v-on:success="onSuccess"
        v-on:error="onError" />

    </div>
  </v-window-item>
  <v-window-item :value="2">
    <products-avg-information 
      :product="selectedProduct" 
      @set-step="setStep" 
      v-on:updated-info="onUpdatedInfo"
      v-on:success="onSuccess"
      v-on:error="onError" />
  </v-window-item>
</v-window>
</v-container>
</template>

<script>
import _ from 'lodash';

import { BASE_PRICE_REQUEST } from '../store/actions/product';

const DEBOUNCE_DELAY = 500;

export default {
  data() {
    return {
      step: 1,
      products: [],
      pictures: {},
      // Autocomplete data
      loading: false,
      serialNumbers: [],
      search: null,
      select: null,

      updatedProducts: [],
      updatedProductsPictures: [],
      //
      selectedProduct: {},
      price_ratio: 100,
      weigth_ratio: 100,
      samples: 1,
      valid: true,

      newProductDialog: false,
    };
  },
  computed: {
    items() {
      return this.serialNumbers.map((entry) => {
        const serialNumber = entry.serial_number;
        return Object.assign({}, entry, {
          serialNumber,
        });
      });
    },
  },
  watch: {
    search(val) {
      return val && val !== this.select && this.querySelections(val);
    },
    select() {
      if (typeof this.select === 'object') {
        this.search = this.select.serial_number;
        this.searchProducts();
      }
    },
    price_ratio() {
      this.debounceSearchProducts();
    },
    weigth_ratio() {
      this.debounceSearchProducts();
    },
    samples() {
      this.debounceSearchProducts();
    },
  },
  methods: {
    async onUpdatedInfo(serialNumber) {
      this.searchProducts();
      // Rigth now we are only changing status and pair of product
      // so we can relay on a search by serial number, if we implement
      // an update for the serial number this is no longer valid.
      const reqBody = {
        serial_number: serialNumber,
        exact: true,
      };
      await this.axios.post('/catalogs/product/search?thumb=80x80', reqBody)
        .then((results) => {
          this.updatedProducts = results.data.products;
          this.updatedProductsPictures = results.data.pictures;
        });
      this.step = 1;
      this.$emit('success', 'Informacion actualizada con exito');

    },

    // This is where the debounce actually belongs.
    debounceSearchProducts: _.debounce(function() {
      this.searchProducts();
    }, DEBOUNCE_DELAY),

    searchProducts() {
      this.loading = true;
      this.$refs.myAutocomplete2.isMenuActive = false;
      const reqBody = {
        serial_number: this.search,
        price_ratio: this.price_ratio,
        weigth_ratio: this.weigth_ratio,
        samples: this.samples,
        pagination: {
          offset: 1,
          per_page: 100,
        },
      };

      this.axios.post('/catalogs/product/search?thumb=80x80', reqBody)
        .then((results) => {
          this.products = results.data.products;
          this.pictures = results.data.pictures;
        })
        .catch((error) => {
          this.$emit('error', error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    disableAutocomplete() {
      this.$refs.myAutocomplete2.isMenuActive = false;
    },

    querySelections: _.debounce(function(v) {
      this.loading = true;
      const reqBody = {
        q: v,
      };
      this.axios.post('/catalogs/product/searchSN', reqBody)
        .then((results) => {
          this.serialNumbers = results.data;
        })
        .catch((error) => {
          this.$emit('error', error);
        })
        .finally(() => {
          this.loading = false;
        });
    }, DEBOUNCE_DELAY),

    selectProduct(product) {
      this.step = 2;
      this.selectedProduct = Object.assign({}, product);
    },

    setStep(step) {
      this.step = step;
    },

    onNewSampleError(event) {
      this.$emit('error', event);
    },

    async onNewSampleSuccess(event) {
      this.newProductDialog = false;
      if (event.serial_number) {
        const reqBody = {
          serial_number: event.serial_number,
          exact: true,
        };
        await this.axios.post('/catalogs/product/search?thumb=80x80', reqBody)
          .then((results) => {
            this.updatedProducts = results.data.products;
            this.updatedProductsPictures = results.data.pictures;
          });
      }
      this.$emit('success', 'Muestra agregada');
    },
    onError(error) {
      this.$emit('error', error);
    },
    onSuccess(payload) {
      this.$emit('success', payload);
    },
  },
  async mounted() {
    this.searchProducts();
    this.$store.dispatch(BASE_PRICE_REQUEST);
  },
};
</script>
